/**
 * Signer Iframe Entry Point
 *
 * This is the main entry point for the isolated signer iframe.
 * Deployed at signer.lumenbro.com
 */

import { initMessageHandler } from './lib/handler';

// Initialize message handler when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

function init(): void {
  console.log('[SignerIframe] LumenBro Session Signer v1.0.0');
  console.log('[SignerIframe] Origin:', window.location.origin);

  // Initialize the message handler
  initMessageHandler();

  // Signal to parent that iframe is ready
  // This is picked up by the iframe's onload event
  console.log('[SignerIframe] Ready to receive messages');
}
